import { SHStack, SHTypography } from "@components/design-systems";
import { RenderAnalysisSummaryItemProps } from "@models/platform-analysis/entities/steps/summary";
import { RootState } from "@redux/store";
import { memo } from "react";
import { useSelector } from "react-redux";
import { AnalysisSummaryPortfolioDetailsTable } from "./table-components/table";

export const SummaryPortfolioDetails = memo(
  ({ name, userType, portfolioLevel }: RenderAnalysisSummaryItemProps) => {
    const storedShowHoldingNumber = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.platformAnalysis?.summary?.feeAnalysis?.all
          ?.isShowHoldingsNumber,
    );
    const storedPortfolioDetails = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.platformAnalysis?.summary?.feePortfolioDetails,
    );
    const storedSelectedSubProducts = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.platformAnalysis?.summary?.feeAnalysis
          ?.shortlisted?.subProducts,
    );
    const storedHiddenIds = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.internal?.feeAnalysis?.hiddenIds,
    );

    return (
      <SHStack>
        <SHTypography variant="subtitle2">{name?.[userType]}</SHTypography>

        <AnalysisSummaryPortfolioDetailsTable
          portfolioDetails={storedPortfolioDetails}
          selectedSubProducts={storedSelectedSubProducts}
          hiddenIds={storedHiddenIds}
          portfolioLevel={portfolioLevel}
          showHoldingsNumber={storedShowHoldingNumber}
        />
      </SHStack>
    );
  },
);
